// extracted by mini-css-extract-plugin
module.exports = {"content":"modal_content__7_9Tb","bottomToTop":"modal_bottomToTop__hOO_t","closing":"modal_closing__TnkUv","topToBottom":"modal_topToBottom__mdXZv"};